import Chart from 'chart.js'

let chart

export const aulasChart = {
  createChart (aulasChartID, containerBodyClass, result) {
    if (chart) {
      chart.destroy()
    }

    // CHART 1
    const autoescolas = result.map(item => item.autoescola.substring(12, item.autoescola.length))
    const alunos = result.map(item => item.alunos)
    const aulas = result.map(item => item.aulas)

    let backOne = []
    let borderOne = []
    let backTwo = []
    let bordertwo = []

    autoescolas.forEach(item => {
      backOne.push('rgba(255, 194, 14, 0.7)')
      backTwo.push('rgba(28, 45, 90, 0.7)')
      borderOne.push('rgba(255, 194, 14, 1)')
      bordertwo.push('rgba(28, 45, 90, 1)')
    })

    const data = {
      labels: autoescolas,
      datasets: [{
        label: 'Aulas',
        data: aulas,
        backgroundColor: backOne,
        borderColor: borderOne,
        borderWidth: 1,
        barPercentage: 0.9,
        categoryPercentage: 0.9,
      },
      {
        label: 'Alunos',
        data: alunos,
        backgroundColor: backTwo,
        borderColor: bordertwo,
        borderWidth: 1,
        barPercentage: 0.9,
        categoryPercentage: 0.9,
      }]
    }

    const config = {
      type: 'bar',
      data,
      options: {
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
          }
        },
      },
    }

    chart = new Chart(
      document.getElementById(aulasChartID),
      config
    )

    const containerBody = document.querySelector(`.${containerBodyClass}`)
    const totalLabels = chart.data.labels.length

    if (totalLabels > 7) {
      const newWidth = 700 + ((totalLabels - 7) * 30)
      containerBody.style.width = `${newWidth}px`
    }
  },
}

const funcs = {
  aulasChartID () { }
}

export default funcs
